var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 3.5C22.7855 3.5 23.379 3.74583 23.8166 4.18342C24.2542 4.621 24.5 5.21449 24.5 5.83333V22.1667C24.5 22.7855 24.2542 23.379 23.8166 23.8166C23.379 24.2542 22.7855 24.5 22.1667 24.5H5.83333C5.21449 24.5 4.621 24.2542 4.18342 23.8166C3.74583 23.379 3.5 22.7855 3.5 22.1667V5.83333C3.5 5.21449 3.74583 4.621 4.18342 4.18342C4.621 3.74583 5.21449 3.5 5.83333 3.5H22.1667ZM21.5833 21.5833V15.4C21.5833 14.3913 21.1826 13.4239 20.4694 12.7106C19.7561 11.9974 18.7887 11.5967 17.78 11.5967C16.7883 11.5967 15.6333 12.2033 15.0733 13.1133V11.8183H11.8183V21.5833H15.0733V15.8317C15.0733 14.9333 15.7967 14.1983 16.695 14.1983C17.1282 14.1983 17.5436 14.3704 17.8499 14.6767C18.1562 14.983 18.3283 15.3985 18.3283 15.8317V21.5833H21.5833ZM8.02667 9.98667C8.54649 9.98667 9.04502 9.78017 9.4126 9.4126C9.78017 9.04502 9.98667 8.54649 9.98667 8.02667C9.98667 6.94167 9.11167 6.055 8.02667 6.055C7.50375 6.055 7.00225 6.26273 6.63249 6.63249C6.26273 7.00225 6.055 7.50375 6.055 8.02667C6.055 9.11167 6.94167 9.98667 8.02667 9.98667ZM9.64833 21.5833V11.8183H6.41667V21.5833H9.64833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab6d3cf80db0cdf645804082c72e2423.svg";
export { ForwardRef as ReactComponent };